import script from "./CSectionTwoColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSectionTwoColumn.vue?vue&type=script&setup=true&lang=ts"

import "./CSectionTwoColumn.vue?vue&type=style&index=0&id=1a16aa48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a16aa48"]])

export default __exports__